import { render, staticRenderFns } from "./RouteSidebar.vue?vue&type=template&id=026a31c6&lang=html&"
import script from "./RouteSidebar.vue?vue&type=script&lang=js&"
export * from "./RouteSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports